import Vue from 'vue'
import 'vuetify/src/stylus/app.styl'
import { Touch } from 'vuetify/lib/directives'
import manifestJSON from '../public/manifest.json'

import {
  Vuetify,
  VApp,
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VDivider,
  VGrid,
  VIcon,
  VList,
  VTextField
} from 'vuetify'

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VDivider,
    VGrid,
    VIcon,
    VList,
    VTextField
  },
  theme: {
    primary: manifestJSON.theme_color
  },
  iconfont: 'md',
  directives: {
    Touch
  }
})
